const ITEMS = [
  "Website Performance",
  "CRM & Lead Tracking",
  "Google Search Ranking",
  "Google Business Profile",
  "Speed to Lead",
];

export const Marquee = () => (
  <div className="relative border-y border-white/10 bg-[#0B162B]/60 py-6 overflow-hidden" data-testid="editorial-marquee">
    <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
      {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className="font-display text-xl sm:text-2xl font-bold uppercase tracking-wide text-white/80">
            {item}
          </span>
          <span className="font-mono-label text-slate-600 text-sm">//</span>
        </span>
      ))}
    </div>
  </div>
);
